import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import modelReducer from './modelSlice';
import simulationReducer from './simulationSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    models: modelReducer,
    simulations: simulationReducer,
  },
});